import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["choices"];

  connect() {
    this.langChoices = false;
  }

  toggleLangChoices() {
    this.langChoices = !this.langChoices;
    this.choicesTarget.classList.toggle("hidden", !this.langChoices);
  }
}